// extracted by mini-css-extract-plugin
export default {"my_select_wrapper":"CustomSelectWithMui_my_select_wrapper__68cWk","my_select":"CustomSelectWithMui_my_select__u9+U-","label":"CustomSelectWithMui_label__N4g2q"};